module.exports = __webpack_public_path__ + "media/Library.b8183ec6.mp3";